import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage8.module.css"
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/om.json";

export default function LaymanPage8() {
  return (
    <>
     <Common_html BlockData={BlockData} />
    </>
  )
}